import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0bdf0708&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0bdf0708&prod&lang=scss&scoped=true&vars=%7B%20sevenDays%20%7D"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdf0708",
  null
  
)

export default component.exports